/* eslint-disable no-console */
import { create, StoreApi, UseBoundStore } from 'zustand';
import getErrorMessage from '../utils/error';
import { IResponse } from '../types/types';
import { getAllCity, getAllDistrict, getAllProvinsi } from '../utils/api';

interface IResponseAddress {
  id: string;
  text: string;
}

interface IUseAddress {
  loading: boolean;
  selectedProvinsi: string | null;
  selectedCity: string | null;
  selectedDistrict: string | null;
  setSelectedProvinsi: (data: string) => void;
  setSelectedCity: (data: string) => void;
  setSelectedDistrict: (data: string) => void;
  provinsi: IResponseAddress[] | null;
  city: IResponseAddress[] | null;
  district: IResponseAddress[] | null;
  fetchAllProvinsi: () => Promise<IResponse>;
  fetchCity: (provinsiId: string) => Promise<IResponse>;
  fetchDistrict: (kabId: string) => Promise<IResponse>;
}

const useAddress: UseBoundStore<StoreApi<IUseAddress>> = create((set) => ({
  loading: false,
  selectedProvinsi: null,
  selectedCity: null,
  selectedDistrict: null,
  provinsi: [],
  city: [],
  district: [],
  setSelectedProvinsi: (data) => set(() => ({ selectedProvinsi: data })),
  setSelectedCity: (data) => set(() => ({ selectedCity: data })),
  setSelectedDistrict: (data) => set(() => ({ selectedDistrict: data })),
  fetchAllProvinsi: async () => {
    try {
      set(() => ({ loading: true }));
      const { success, message, data } = await getAllProvinsi();

      if (!success) {
        throw new Error(message);
      }

      set(() => ({ provinsi: data }));

      return {
        success: true,
        message,
      };
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
      return {
        success: false,
        message: errorMessage,
      };
    } finally {
      set(() => ({ loading: false }));
    }
  },
  fetchCity: async (provinsiId) => {
    try {
      set(() => ({ loading: true }));
      const { success, message, data } = await getAllCity(provinsiId);

      if (!success) {
        throw new Error(message);
      }

      set(() => ({ city: data }));

      return {
        success: true,
        message,
      };
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
      return {
        success: false,
        message: errorMessage,
      };
    } finally {
      set(() => ({ loading: false }));
    }
  },
  fetchDistrict: async (kabId) => {
    try {
      set(() => ({ loading: true }));
      const { success, message, data } = await getAllDistrict(kabId);

      if (!success) {
        throw new Error(message);
      }

      set(() => ({ district: data }));

      return {
        success: true,
        message,
      };
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
      return {
        success: false,
        message: errorMessage,
      };
    } finally {
      set(() => ({ loading: false }));
    }
  },
}));

// Subscribe untuk mengecek perubahan state
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const unsubscribe = useAddress.subscribe((state) => {
//   console.log('State address:', state);
// });

export default useAddress;
